import { render, staticRenderFns } from "./SubmenuBack.vue?vue&type=template&id=6cfd4e96&"
import script from "./SubmenuBack.vue?vue&type=script&lang=js&"
export * from "./SubmenuBack.vue?vue&type=script&lang=js&"
import style0 from "./SubmenuBack.vue?vue&type=style&index=0&id=6cfd4e96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports